import { render } from "./activity-compose-step2.vue?vue&type=template&id=35ddd3bd"
import script from "./activity-compose-step2.vue?vue&type=script&lang=js"
export * from "./activity-compose-step2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__